const SORT_BY_DATE = 'created_at'
const SORT_BY_HEARTS = 'hearts_count'

export {
    SORT_BY_DATE,
    SORT_BY_HEARTS
}



// WEBPACK FOOTER //
// ./src/types/index.js